import type { ReactElement } from "react";
import {
  components,
  type GroupBase,
  type SingleValueProps,
} from "react-select";

import type { DropdownOption } from "../../common/utils/optionTransformers";

export const GoodsTypeDropdownSingleValue = <
  TValue extends DropdownOption<unknown>,
>({
  ...optionProps
}: SingleValueProps<TValue, false, GroupBase<TValue>>): ReactElement<
  SingleValueProps<TValue>
> => (
  <components.SingleValue {...optionProps}>
    {optionProps.data.value}
  </components.SingleValue>
);
